/* global angular, moment */
/**
 * Created by lari on 03/05/2017.
 */
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcclient.factory:ClientHelper
   *
   * @description
   *
   */
  angular
    .module('vcclient')
    .factory('ClientHelper', ClientHelper);

  ClientHelper.$inject = ['Client', 'Patient', '$http', '$log'];

  function ClientHelper(Client, Patient, $http, $log) {
    let service = {};

    service.getAll = function (query, mode) {
      if (mode === 'patient') {
        return Patient.$search(query);
      } else {
        return Client.$search(query);
      }
    };

    service.search = function (query, mode) {
      if (mode === 'patient') {
        return Patient.$search(query);
      } else {
        return Client.$search(query);
      }
    };

    service.create = function (client, mode) {
      if (mode === 'patient') {
        return Patient.$create(client);
      } else {
        return Client.$create(client);
      }
    };

    service.searchahead = function (query, mode) {
      if (mode === 'patient') {
        return Patient.$searchahead(query);
      } else {
        return Client.$searchahead(query);
      }
    };

    service.find = function (mode, id) {
      if (mode === 'patient') {
        return Patient.$find(id);
      } else {
        return Client.$find(id);
      }
    };


    service.fname = function (client, mode) {
      if (mode === 'patient') {
        client.text = '';
        if (angular.isDefined(client.primarycontact) && angular.isDefined(client.primarycontact.firstname)) {
          client.text += client.primarycontact.firstname + ' ';
        }
        client.text += client.primarycontact.lastname;
        if (angular.isDefined(client.svdata.bdateat)) {
          client.text += ', ' + client.svdata.bdateat;
        }
        if (angular.isDefined(client.companydata.name)) {
          client.text += ', ' + client.companydata.name;
        }
      } else {
        client.text = '';
        if (angular.isDefined(client.companydata.name)) {
          client.text += client.companydata.name + ', ';
        }
        if (angular.isDefined(client.primarycontact.firstname)) {
          client.text += client.primarycontact.firstname;
        }
        if (angular.isDefined(client.primarycontact.lastname)) {
          client.text += ' ' + client.primarycontact.lastname;
        }
      }
    };


    service.diagname = function (client, mode, searchterm) {
      if (mode === 'patient') {
        client.text = '';
        if (angular.isDefined(client.primarycontact) && angular.isDefined(client.primarycontact.firstname)) {
          client.text += client.primarycontact.firstname + ' ';
        }
        client.text += client.primarycontact.lastname;
        if (angular.isDefined(client.svdata) && angular.isDefined(client.svdata.bdateat)) {
          client.text += ', ' + client.svdata.bdateat;
        }

        if (angular.isDefined(client.companydata.name)) {
          client.text += ', ' + client.companydata.name;
        }
        if (angular.isDefined(client.flatdiagnoses) && client.flatdiagnoses.length > 0) {
          // $log.debug('[CLIENT][HELPER] flatdiagnoses, searchterm: ',client.flatdiagnoses, searchterm);
          let filtereddiags = client.flatdiagnoses.filter(d => d.includes(searchterm));
          // $log.debug('[CLIENT][HELPER] filtereddiags: ',filtereddiags);

          if (filtereddiags.length > 0) {
            client.text += ', ' + filtereddiags;
          }
        }
      } else {
        client.text = '';
        if (angular.isDefined(client.companydata) && angular.isDefined(client.companydata.name)) {
          client.text += client.companydata.name + ', ';
        }
        if (angular.isDefined(client.primarycontact.firstname)) {
          client.text += client.primarycontact.firstname;
        }
        if (angular.isDefined(client.primarycontact.lastname)) {
          client.text += ' ' + client.primarycontact.lastname;
        }
      }
    };

    return service;
  }


  // klammerfriedhof
}());
